import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconPin = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.8777 3.26152C11.2269 2.61065 10.1716 2.61065 9.52071 3.26152C8.89253 3.8897 8.87062 4.89457 9.455 5.54901L5.6956 7.25783C4.63623 7.73936 4.38392 9.13078 5.20676 9.95362L10.0552 14.802C10.878 15.6249 12.2694 15.3725 12.7509 14.3132L14.471 10.5291C15.1201 10.9751 16.0148 10.9095 16.5918 10.3326C17.2426 9.68171 17.2426 8.62644 16.5918 7.97556L11.8777 3.26152Z",
		fill: "#60A5FA"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.91671 15.9129L7.0415 11.7881L8.22002 12.9666L4.09523 17.0914L2.91671 15.9129Z",
		fill: "#93C5FD"
	})]
});
export default SvgIconPin;
